import { Grid } from '@mui/material';

const FulfillmentDetails = () => {
    return (
        <Grid container width={'100%'} justifyContent={'center'} padding={'15px'}>
            <Grid item padding={'2rem'}>
                <h1>CPE Online Academy Learning Platform Fulfillment Policy</h1>

                <h2>Service Access</h2>
                <ul>
                    <li>
                        Upon successful payment of $700, you will receive full access to our online learning platform
                        for a period of 3 months. (Options exist for 1 or 2 month periods of access as well, though
                        pricing changes based upon duration)
                    </li>
                    <li>
                        Access begins immediately after payment confirmation, as soon as a member of the CPE Online
                        Academy Team is able to create your account which will issue you an email to set your password.
                    </li>
                    <li>
                        Your subscription includes all standard learning materials, modules, and features as advertised
                        on our platform.
                    </li>
                </ul>

                <h2>Payment & Refund Policy</h2>
                <ul>
                    <li>
                        The full $700 payment is due at the time of registration. Following confirmation steps of
                        enrollment in the ECFVG CPE Program.
                    </li>
                    <li>
                        A 2 day refund window exists if for some reason the application can not be utilized by you to
                        access the study materials.
                    </li>
                    <li>
                        To request a refund within this 2-day window, please contact our customer support team at{' '}
                        <a
                            href="mailto:management@cpeonlineacademy.com?subject=Request Refund"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Support
                        </a>
                        .
                    </li>
                    <li>
                        No refunds will be processed after the 2-day period has elapsed, unless necessary cause can be
                        justified.
                    </li>
                </ul>

                <h2>Privacy & Data Practices</h2>
                <ul>
                    <li>We implement industry best practices for data privacy and protection.</li>
                    <li>
                        Only essential authentication and authorization cookies are used to maintain your secure access
                        to the platform.
                    </li>
                    <li>No tracking cookies or third-party monitoring tools are employed.</li>
                    <li>
                        Your personal information is stored securely and only used for the purposes of providing our
                        service. No information is gathered around or provided to any advertisers.
                    </li>
                </ul>

                <h2>Data Retention</h2>
                <ul>
                    <li>
                        Your account information and learning progress are maintained for the duration of your
                        subscription.
                    </li>
                    <li>
                        Upon subscription expiration, your access will be suspended but your data will be retained for a
                        period of 12 months should you wish to renew. Upon renewal this window of retention will
                        recommence upon the last day of your access period.
                    </li>
                    <li>
                        You may request complete deletion of your data at any time by contacting{' '}
                        <a
                            href="mailto:management@cpeonlineacademy.com?subject=Request Data Deletion"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Support
                        </a>
                    </li>
                </ul>

                <h2>Technical Requirements</h2>
                <ul>
                    <li>
                        Users are responsible for ensuring they have compatible devices and sufficient internet
                        connectivity to access the platform.
                    </li>
                    <li>We recommend using up-to-date browsers for optimal performance.</li>
                </ul>

                <h2>Service Modifications</h2>
                <ul>
                    <li>
                        We reserve the right to make technical updates or improvements to the platform during your
                        subscription period.
                    </li>
                    <li>
                        Any significant changes to service terms will be communicated to you via your registered email
                        address.
                    </li>
                </ul>
            </Grid>
        </Grid>
    );
};

export default FulfillmentDetails;
